export { default as NewCredConfig } from "./NewCredConfig";
